import { createCrudHooks as baseCreateCrudHooks } from '@markku/components'
import { trpc } from '../trpc'

/**
 * Resident app-specific CRUD hooks - no notifications
 */
export function createCrudHooks<
  TItem,
  TListResult = TItem,
  TCreateInput = Partial<TItem>,
  TUpdateInput = Partial<TItem>,
  TFilterType = TItem,
>(resourceName: string) {
  return baseCreateCrudHooks<
    TItem,
    TListResult,
    TCreateInput,
    TUpdateInput,
    TFilterType
  >({
    trpc,
    resourceName,
    showNotifications: false,
  })
}
